import api from './api'

export default class BaseService {
  static getSession () {
    return api.get('/session')
  }

  static restoreSession (redirectUri) {
    return api.post('/session', {
      redirect_uri: redirectUri
    })
  }

  static startAuthorization (method, credentials, locale) {
    const data = {}
    if (method) {
      data.method = method
    }
    if (credentials && Object.keys(credentials).length) {
      data.credentials = credentials
    }
    if (locale) {
      data.locale = locale
    }
    return api.post('/start-authorization', data)
  }

  static continueAuthorization (data, locale) {
    if (data === undefined) {
      data = {}
    }
    if (locale) {
      data.locale = locale
    }
    return api.post('/continue-authorization', data)
  }

  static cancelAuth () {
    return api.post('/cancel-authorization')
  }

  static notifyLeaving () {
    return api.post('/leaving')
  }

  static confirmConsent () {
    return api.post('/confirm-consent')
  }

  static submitPaymentAccountSelection (data) {
    return api.post('/confirm-account-selections', data)
  }
}
